import { render, staticRenderFns } from "./ObraRecommendations.vue?vue&type=template&id=20a40bb9"
import script from "./ObraRecommendations.vue?vue&type=script&lang=js"
export * from "./ObraRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports